import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";
import convertObjectKeysToSnakeCase from "@/utils/convertObjectKeysToSnakeCase";

const useResetPasswordPost = () => {
  const resetPasswordRequest = useCallback(({ id, ...payload }) => {
    const requestConfig = {
      method: "POST",
      body: JSON.stringify(convertObjectKeysToSnakeCase(payload)),
      headers: { "Content-Type": "application/json" },
    };

    return new Request(
      `${API_BASE_URL}/api/v2/user/${id}/password/`,
      requestConfig,
    );
  }, []);

  return useRestMutation(resetPasswordRequest);
};

export default useResetPasswordPost;
